import BaseApi from '~/api/base';
class TaggableUsers extends BaseApi {
    constructor() {
        super('/taggable-users');
    }
    getClauseUsers() {
        return super.route('/taggable-users/clauses').get();
    }
    getComparisonUsers() {
        return super.route('/taggable-users/comparisons').get();
    }
}
const TaggableUsersApi = new TaggableUsers();
export default TaggableUsersApi;
